import React from "react";
import classNames from "../../classNames";

function ProgressBar({ className, progress, children, color }) {
  const classes = classNames(className, "progress");
  return (
    <div className={classes} role="progressbar">
      <div
        className="progress-bar"
        style={{ width: `${progress}%`, backgroundColor: `${color}` }}
      >
        {children}
      </div>
    </div>
  );
}

export default ProgressBar;
